import type { IconData } from '@stacksjs/iconify-core'

export const ma1x1: IconData = {
  "body": "<path fill=\"#c1272d\" d=\"M512 0H0v512h512z\"/><path fill=\"none\" stroke=\"#006233\" stroke-width=\"12.5\" d=\"m256 191.4l-38 116.8l99.4-72.2H194.6l99.3 72.2z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ma1x1
